import { gql } from '@apollo/client';

export const SEND_TRANSACTIONAL_MESSAGE = gql`
  mutation SendTransactionalMessage($messageId: String!, $to: String!, $trigger: JSON!, $replyTo: String) {
    sendTransactionalMessage(messageId: $messageId, to: $to, trigger: $trigger, replyTo: $replyTo)
  }
`;
